import React from "react";

const DonutChart = ({ data, size = 160, strokeWidth = 24 }) => {
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  let currentOffset = 0;

  return (
    <svg width={size} height={size} className="transform -rotate-90">
      {data.map((segment, idx) => {
        const percentage = total > 0 ? segment.value / total : 0;
        const strokeDasharray = `${circumference * percentage} ${circumference * (1 - percentage)}`;
        const strokeDashoffset = -currentOffset;
        currentOffset += circumference * percentage;

        return (
          <circle
            key={idx}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="transparent"
            stroke={segment.color}
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            className="transition-all duration-500"
          />
        );
      })}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius - strokeWidth / 2}
        fill="transparent"
      />
    </svg>
  );
};

export default DonutChart;
